'use client';

import { useEffect } from 'react';

export default function GsapInit() {
  useEffect(() => {
    const loadGsap = async () => {
      const { gsap } = await import('gsap');
      const { ScrollTrigger } = await import('gsap/ScrollTrigger');
      gsap.registerPlugin(ScrollTrigger);

      // Global scroll-triggered reveals
      const revealEls = document.querySelectorAll('.gsap-reveal');
      revealEls.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 40, filter: 'blur(6px)' },
          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.9,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 88%',
              once: true,
            },
          }
        );
      });

      // Stagger children
      const staggerContainers = document.querySelectorAll('.gsap-stagger');
      staggerContainers.forEach((container) => {
        const children = container.querySelectorAll('.gsap-stagger-item');
        gsap.fromTo(
          children,
          { opacity: 0, y: 50, filter: 'blur(4px)' },
          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.12,
            scrollTrigger: {
              trigger: container,
              start: 'top 85%',
              once: true,
            },
          }
        );
      });

      // Spotlight card mouse tracking
      const spotlightCards = document.querySelectorAll('.spotlight-card');
      document.addEventListener('mousemove', (e) => {
        spotlightCards.forEach((card) => {
          const rect = (card as HTMLElement).getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          (card as HTMLElement).style.setProperty('--mouse-x', `${x}px`);
          (card as HTMLElement).style.setProperty('--mouse-y', `${y}px`);
        });
      });
    };

    loadGsap();
  }, []);

  return null;
}